/**
* Profile landing
* Created by Min on 10/08/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'
import AppButton from '../AppButton'

// style import
import './style.scss'

class ProfileLanding extends Component {
    renderProfile() {
        const { data } = this.props
        return (
            <div>
                <div className="profile-item">
                    <div className="profile-item__label">First name</div>
                    <div className="profile-item__value">{data['first_name']}</div>
                </div>
                <div className="profile-item">
                    <div className="profile-item__label">Email</div>
                    <div className="profile-item__value">{data['email']}</div>
                </div>
                <div className="profile-item">
                    <div className="profile-item__label">Phone</div>
                    <div className="profile-item__value">{data['phone']}</div>
                </div>
                <div className="profile-item">
                    <div className="profile-item__label">Password</div>
                    <div className="profile-item__value">********</div>
                </div>
                <AppButton
                    buttonText="Edit"
                    size="big"
                    color="blue"
                    onClick={()=>{this.props.editProfile(true)}}
                />
            </div>
        )
    }

    render() {
        return (
            <div className="profile-landing">
                    {this.renderProfile()}
            </div>

        )
    }
}

// define the prop types
ProfileLanding.propTypes = {
    data: PropTypes.object,
    isLoading:  PropTypes.bool,
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        editProfile: action.editProfile,
    }
}

export default connect(null,mapDispatchToProps)(ProfileLanding)



// WEBPACK FOOTER //
// ./src/components/ProfileLanding/index.js